<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>Coupons </h2>
                </div>
                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  
                </div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                    (mouseout)="showpayment(false,'1')" id='1' >
                    <div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe class="i-frame" src="https://www.youtube.com/embed/RLUj"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div> -->
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id='2'>

                    <h2 class="mt-2"> What is a coupon?</h2>
                    <label for="">A coupon typically refers to a promotional code or discount voucher that customers can
                        use during the checkout process to receive a discount on their purchase. PayG often integrates
                        coupon functionality, allowing merchants to create and manage promotions.</label>
                </div>

                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id='3'>
                    <h2 class="mt-3">Here's how it generally works:</h2>
                    <label for="" class="mt-3"><b> Creation:&nbsp;</b>Merchants can create coupon codes with specific
                        discount values, percentages, or other promotional offers.</label>
                    <label for="" class="mt-3"><b> Distribution: &nbsp;</b>Merchants can distribute these coupon codes
                        to customers through various channels, such as email, social media, or advertisements.</label>
                    <label for="" class="mt-3"><b>Redemption: &nbsp;</b> Customers enter the coupon code during
                        checkout. PayG verifies the code and applies the associated discount to the transaction
                        amount.</label>
                    <label for="" class="mt-3"><b> Processing: &nbsp;</b>PayG processes the discounted transaction
                        amount, and the remaining balance is charged to the customer's chosen payment method.</label>
                    <label for="" class="mt-3">Coupons can be an effective tool for merchants to attract new customers,
                        retain existing ones, and drive sales. PayG plays a crucial role in facilitating the seamless
                        integration of coupon functionality into the online payment process for merchants.</label>
                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')"
                    id='4'>
                    <h2 class="mt-3">How do Coupons help merchants?</h2>
                    <label for="">In the ever-evolving landscape of e-commerce, staying ahead of the competition and
                        maximizing your revenue is crucial. One powerful tool at your disposal is the strategic use of
                        coupons. Here's why coupons are essential for merchants like you and how they can significantly
                        impact your business:</label>


                    <label for="" class="mt-3"><b> Customer Acquisition:&nbsp;</b> Coupons are a compelling incentive
                        for new customers to choose your products or services over competitors.</label>
                    <label for="">Offering a discount on the first purchase encourages potential buyers to take that
                        initial step and experience what your business has to offer.</label>

                    <label for="" class="mt-3"><b> Customer Retention&nbsp;</b>Coupons aren't just for attracting new
                        customers; they are equally effective in retaining existing ones.</label>
                    <label for="">Implementing loyalty programs with exclusive discounts for repeat customers builds a
                        sense of appreciation and encourages continued patronage.</label>

                    <label for="" class="mt-3"><b> Sales Boost: &nbsp;</b>Running targeted promotions with well-designed
                        coupons can drive short-term sales spikes.</label>
                    <label for="">Limited time offers create a sense of urgency, motivating customers to make a purchase
                        sooner rather than later.</label>

                    <label for="" class="mt-3"><b> Marketing Opportunities: &nbsp;</b>Coupons serve as valuable tools
                        for marketing campaigns, allowing you to track the success of specific promotions.</label>
                    <label for="">Leverage coupons across various channels, such as email, social media, and
                        partnerships, to expand your reach and engage a wider audience.</label>

                    <label for="" class="mt-3"><b>Clearing Inventory: &nbsp;</b>Use coupons strategically to move
                        inventory quickly, especially if you have surplus stock or seasonal items.</label>
                    <label for="">Clearance sales with attractive discounts can turn slow-moving products into revenue,
                        preventing excess stock and potential losses.</label>

                    <label for="" class="mt-3"><b> Customer Engagement:&nbsp;</b>Coupons provide an interactive element
                        to your marketing strategy, fostering engagement with your audience.</label>
                    <label for="">Encourage social sharing by creating promotions that reward customers for referring
                        friends or sharing their purchases on social media.</label>

                    <label for="" class="mt-3"><b>Data Collection: &nbsp;</b>Require customers to sign up or provide
                        information in exchange for coupon codes, helping you build a valuable database for future
                        marketing efforts.</label>
                    <label for="">Understand your customer demographics better and tailor future promotions based on
                        collected data.</label>

                    <label for="" class="mt-3"><b>Competitive Edge: &nbsp;</b>In a competitive market, offering
                        discounts can be a differentiator that sets your business apart.</label>
                    <label for="">Stay top-of-mind for consumers actively seeking the best deals and promotions</label>
                </div>

                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'5')" (mouseout)="showpayment(false,'5')"
                    id='5'>
                    <h2 class="mt-3">Why use PayG’s Coupons:</h2>
                    <label for="" class="mt-4"><b> Customization and Flexibility:&nbsp;</b>Our coupon system is highly
                        customizable, allowing you to create promotions that align with your brand and marketing
                        strategy.</label>
                    <label for="">Set specific discount values, and percentage-offs, or create buy-one-get-one (BOGO)
                        offers to suit the diverse needs of your customer base.</label>


                    <label for="" class="mt-4"><b>Targeted Promotions: &nbsp;</b> Take advantage of our advanced
                        targeting options to reach specific customer segments.</label>
                    <label for="">Tailor promotions based on customer demographics, purchase history, or other criteria
                        to maximize the impact of your campaigns.</label>


                    <label for="" class="mt-4"><b>Seamless Integration: &nbsp;</b> Our coupon functionality seamlessly
                        integrates with your existing checkout process, providing a smooth experience for both you and
                        your customers.</label>
                    <label for="">No complicated setup – simply create and manage coupons directly through our
                        user-friendly merchant dashboard.</label>


                    <label for="" class="mt-4"><b>Real-time Analytics: &nbsp;</b>Gain insights into the performance of
                        your promotions with real-time analytics.</label>
                    <label for="">Track coupon redemptions, customer engagement, and overall campaign success to make
                        data-driven decisions for future marketing strategies.</label>


                    <label for="" class="mt-4"><b>Multi-Channel Distribution: &nbsp;</b>Amplify your reach by
                        distributing coupons across various channels.</label>
                    <label for="">Easily share promotions through email campaigns, social media, or even partner
                        collaborations to ensure maximum exposure.</label>
                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'6')" (mouseout)="showpayment(false,'6')"
                    id='6'>
                    <h2 class="mt-4">   Benefits for Merchants:</h2>

                    <label for="" class="mt-4"><b>Increased Conversion Rates: &nbsp;</b>Our strategically designed coupons are proven to boost conversion rates, turning potential customers into loyal patrons.</label>
                    <label for="" class="mt-4"><b> Brand Loyalty and Retention: &nbsp;</b> Foster long-term relationships with your customers by offering exclusive discounts and promotions that keep them coming back.</label>
                    <label for="" class="mt-4"><b>Competitive Edge: &nbsp;</b>Stay ahead of the competition by leveraging unique and enticing promotions that capture the attention of your target audience.</label>
                    <label for="" class="mt-4"><b> Effortless Management: &nbsp;</b>Our intuitive dashboard makes it easy to create, monitor, and adjust your coupon campaigns without the need for technical expertise.</label>
                    <label for="" class="mt-4"><b>Data-Driven Marketing:  &nbsp;</b>Utilize the wealth of data generated by our coupon system to refine your marketing strategies and optimize future campaigns.</label>
               
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4  hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        Table of Contents:
                    </h5>

                </div>
                <div class="col-md-12 mt-2">
                    <!-- <a href="#1">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="videoHover"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                                   
Creating Booking and Ticketing Profile
</span>
                            </div>
                        </div>
                    </a> -->
                </div>

                <div class="col-md-12 mt-3">
                    <a href="#2">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')">

                                    What is a coupon?
                                </span>

                            </div>
                        </div>
                    </a>
                </div>

                <div class="col-md-12 mt-3">
                    <a href="#3">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')">

                                    How it works?
                                </span>

                            </div>
                        </div>
                    </a>
                </div>

                <div class="col-md-12 mt-3">
                    <a href="#4">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')">

                                    How does it help?
                                </span>

                            </div>
                        </div>
                    </a>
                </div>

                <div class="col-md-12 mt-3">
                    <a href="#5">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='5'}"
                                    (click)="color('5')">

                                    Why use PayG’s Coupons? 
                                </span>

                            </div>
                        </div>
                    </a>
                </div>

                <div class="col-md-12 mt-3">
                    <a href="#6">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='6'}"
                                    (click)="color('6')">
                                    Benefits of coupons
                                </span>

                            </div>
                        </div>
                    </a>
                </div>

            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8" style="width:70%">
                <a [routerLink]="['/features']"> <button class="btn btn-color" > <img
                            src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;Pay feature
                    </button></a>

            </div>
            <div class="col-md-4        " style="width:30%">
                <a [routerLink]="['/price']"> <button class="btn btn-color"
                        (click)="menues('Web Integration')">Price Match
                        &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>

            </div>
        </div>
    </div>
</div>